import React from "react";

export interface ExamPassageUIProps {
  // Content
  passage?: string;
  subject?: string;
  examType?: string;
  answerType?: string;

  // Mode-specific content
  mathDirectionsContent?: React.ReactNode;
  highlightableContent?: React.ReactNode;

  // Display options
  showPassage?: boolean;
  mode?: "exam" | "result" | "demo";

  // Event handlers
  onSaveHighlight?: (
    contentType: "passage" | "question",
    newContent: string
  ) => void;
}

const ExamPassageUI: React.FC<ExamPassageUIProps> = ({
  passage = "",
  subject,
  examType,
  answerType,
  mathDirectionsContent,
  highlightableContent,
  showPassage = true,
  mode = "exam",
  onSaveHighlight,
}) => {
  // SAT Math일 때는 passage를 보여주지 않음
  if (examType === "SAT" && subject === "Math") {
    // Math 타입이고 short_answer일 때
    if (answerType === "short_answer" && mathDirectionsContent) {
      return mathDirectionsContent as React.ReactElement;
    }
    // 그 외의 Math 경우
    return null;
  }

  // Passage가 없거나 표시하지 않는 경우
  if (!showPassage || !passage) {
    return null;
  }

  return (
    <div className="w-1/2 h-full overflow-auto p-8 bg-white border-r border-gray-200">
      {highlightableContent ? (
        // Use custom highlightable content if provided
        <div className="max-w-[650px] w-full">{highlightableContent}</div>
      ) : (
        // Default passage display
        <div className="max-w-[650px] w-full">
          <div className="prose prose-lg leading-relaxed">
            <div
              className="whitespace-pre-wrap text-[18px] text-gray-900 leading-relaxed font-serif font-times [&_img]:block [&_img]:mx-auto"
              style={{ fontFamily: '"Times New Roman", Times, serif' }}
              dangerouslySetInnerHTML={{ __html: passage }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default ExamPassageUI;
